import { render, staticRenderFns } from "./SkillsPopup.vue?vue&type=template&id=22a27bde"
import script from "./SkillsPopup.vue?vue&type=script&lang=js"
export * from "./SkillsPopup.vue?vue&type=script&lang=js"
import style0 from "./SkillsPopup.vue?vue&type=style&index=0&id=22a27bde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports